import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.bookingHistory.label",
    defaultMessage: "Overview",
    description: "Button label to open booking history",
  },
});
